import { render, staticRenderFns } from "./m_common.vue?vue&type=template&id=a9ed9c36"
import script from "./m_common.vue?vue&type=script&lang=js"
export * from "./m_common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports